import { ExchangeInfoType } from "src/Modules/PointsExchange/constants";
import { PointsExchangeItem } from "src/store/slices/item/subitems/px.types";

const formulateOrderRequest = ({
  pointsBefore,
  program,
  exchangeInfo,
  requiredFieldsInputs,
}: {
  pointsBefore: number;
  program: string;
  exchangeInfo: ExchangeInfoType;
  requiredFieldsInputs?: Record<string, string>;
}) => {
  const { sentValue } = getPointsAfterConversion(pointsBefore, exchangeInfo.conversionRate, exchangeInfo.fees);

  return {
    externalTransactionId: `ext-client_${program}-${crypto.randomUUID()}`,
    orderItems: [{
      itemCode: program,
      quantity: 1,
      value: sentValue,
      points:pointsBefore,
      requiredFields: Object.entries(requiredFieldsInputs ?? {}).map(([key, value]) => ({ key, value })),
    }],
  };
};



const getPointsAfterConversion = (pointsBefore:number, conversionRate:number, fees:number)=>{
    const actualValue = pointsBefore * conversionRate * (1 - fees / 100);
    const sentValue = Math.floor(actualValue);
    return {actualValue, sentValue};
}

const getPointsBeforeConversion = (pointsAfter: number, conversionRate: number, fees: number) => {
    const rate = conversionRate * (1 - fees / 100);
    const actualValue = pointsAfter / rate;
    const sentValue = Math.ceil(actualValue);
    return { actualValue, sentValue };
};

const getDestinationProgramData = (program: PointsExchangeItem) => {
  const { termsAndConditions, requiredFields, conversionRate = 1, fees = 0, name ,from, to, code, imageUrl,unitLabel } = program;
    const {sentValue:min} = getPointsBeforeConversion(from, conversionRate, fees);
    const max = Math.floor(getPointsBeforeConversion(to, conversionRate, fees).actualValue);

  return {
    destinationProgram: { name, value: code, imageUrl, unitLabel: unitLabel ?? undefined },
    exchangeInfo: { conversionRate, fees, min, max, destinationUnitLabel: unitLabel ?? "" },
    termsAndConditions: termsAndConditions ?? "",
    requiredFields,
  };
};

export { formulateOrderRequest, getDestinationProgramData, getPointsAfterConversion, getPointsBeforeConversion };
